import React,{useEffect, useState,useRef} from 'react'
import withFmsLayout from '../layout/withFmsLayout'
import GenerateBarcode from '../components/GenerateBarcode';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { useAlert } from '../../../context/AlertContext';
import barcodeServices from '../services/barcodeServices';
import PrintBarcode from '../components/PrintBarcode';

const CellPrint = (params) =>{
  return (
    <button className='btn btn-sm btn-primary' onClick={()=>params.setSelectedBatch(params.data.id)}>Print</button>
  )
      
}

function BarcodeListPage() {
  const [dialogStatus, setDialogStatus] = useState(false);
  const {AppAlert} = useAlert();
  const [batchList,setBatchList] = useState(null);

  const [selectedBatch,setSelectedBatch] = useState(null);

  const getBatchList = () => {
    barcodeServices.getBatchList().then(res=>{
        setBatchList(res.data);
    }).catch(error=>{
    })
  }

  /* Grid Work */
  const gridRef = useRef();
  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:180,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });
  
  const columnDefs = [
    {field:"id",headerName: "ID"},
    {field:"firstName",headerName:"CreatedBy"},
    {field:"created_at",headerName:"CreatedOn"},
    {field:"total",headerName:"Total Count"},
    {field:"pending",headerName:"Pending Count"},
    {headerName:"Status", width:"200", cellRenderer: CellPrint, cellRendererParams: { setSelectedBatch:setSelectedBatch}},
  ];
            


  return (
    <div className='row'>
      <div className='col-md-12'>
        <span className='float-end'><GenerateBarcode callback={getBatchList} /></span>
      </div>
      <div className='col-md-12 mt-3'>
        <PrintBarcode batchId={selectedBatch} />
        <div className="ag-theme-alpine" style={{height:600}}>
            <AgGridReact
                ref={gridRef}
                rowData={batchList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getBatchList}
            />
        </div>
      </div>
    </div>
  )
}

export default withFmsLayout(BarcodeListPage);